import { tv } from "../../../variants/tv.js";
const radioChipGroupVariants = tv({
    slots: {
        radioChipGroup: 'relative flex flex-col items-start gap-2'
    },
    variants: {
        layout: {
            vertical: {},
            horizontal: {
                radioChipGroup: 'flex-row flex-wrap items-center justify-start gap-3'
            }
        }
    },
    compoundVariants: [],
    defaultVariants: {
        layout: 'vertical'
    }
});
export { radioChipGroupVariants };
